import { useEffect, useRef, useState } from "react"
import Icon from "@mui/material/Icon"
import MDBox from "components/MDBox"
import MDButton from "components/MDButton"
import MDInput from "components/MDInput"
import MDTypography from "components/MDTypography"

// Compact rule identity block: the intent line ("Creating new rule"), the rule
// name with inline edit, and the version. Sits at the top of the workspace.
const RuleEditorHeader = ({ rule, isNew, onRename }) => {
  const ruleData = rule.rule || rule
  const [editing, setEditing] = useState(false)
  const [value, setValue] = useState(ruleData.name || "")
  const inputRef = useRef(null)

  useEffect(() => {
    setValue(ruleData.name || "")
  }, [ruleData.name])

  useEffect(() => {
    if (editing && inputRef.current) inputRef.current.focus()
  }, [editing])

  const commit = () => {
    setEditing(false)
    if (onRename) onRename(value.trim())
  }

  return (
    <MDBox sx={{ minWidth: { md: 240 } }}>
      <MDTypography variant="caption" color="text" display="block" mb={0.5}>
        {isNew ? "Creating new rule" : "Editing rule"}
      </MDTypography>

      {editing ? (
        <MDInput
          inputRef={inputRef}
          value={value}
          placeholder="Untitled rule"
          onChange={(e) => setValue(e.target.value)}
          onBlur={commit}
          onKeyDown={(e) => {
            if (e.key === "Enter") commit()
            if (e.key === "Escape") setEditing(false)
          }}
          sx={{ maxWidth: 320 }}
        />
      ) : (
        <MDBox display="flex" alignItems="center" gap={0.75}>
          <MDTypography variant="h5" fontWeight="bold">
            {ruleData.name?.trim() || "Untitled rule"}
          </MDTypography>
          <MDButton
            variant="text"
            color="secondary"
            iconOnly
            size="small"
            onClick={() => setEditing(true)}
            aria-label="Rename rule"
          >
            <Icon fontSize="small">edit</Icon>
          </MDButton>
        </MDBox>
      )}

      {ruleData.version != null && (
        <MDTypography variant="caption" color="text" display="block" mt={0.5}>
          Version v{ruleData.version}
        </MDTypography>
      )}
    </MDBox>
  )
}

export default RuleEditorHeader
